import { render, staticRenderFns } from "./AccountMultiple.vue?vue&type=template&id=09b87804&"
import script from "./AccountMultiple.vue?vue&type=script&lang=js&"
export * from "./AccountMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports